import { Injectable } from '@angular/core';
import { FormTemplateInterface } from '@rx-applications/shared/utils-forms';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ControlsOf } from '@rx-applications/shared/utils';
import { LoyaltyCard, LoyaltyCardForm } from '../../models';
import { GuestsForm } from '../guest-form/guest-form.service';
import { RxValidators } from '@roomex/rx-components';

@Injectable({
  providedIn: 'root',
})
export class LoyaltyFormService implements FormTemplateInterface<LoyaltyCard> {
  constructor(private formBuilder: FormBuilder) {}

  getTemplate(defaultValue?: LoyaltyCard): FormGroup<ControlsOf<LoyaltyCardForm>> {
    return this.formBuilder.group<ControlsOf<LoyaltyCardForm>>({
      loyaltyCardId: this.formBuilder.control(defaultValue?.loyaltyCardId),
      loyaltyProgramId: this.formBuilder.control(
        defaultValue?.loyaltyProgramId,
        RxValidators.dependentRequiredValidator('cardNumber')
      ),
      loyaltyProgramName: this.formBuilder.control(defaultValue?.loyaltyProgramName),
      cardNumber: this.formBuilder.control(
        defaultValue?.cardNumber,
        RxValidators.dependentRequiredValidator('loyaltyProgramId')
      ),
      toBeDeleted: this.formBuilder.control(false),
    });
  }

  addLoyaltyConfirmedControl(form: FormGroup<ControlsOf<GuestsForm>>): void {
    form.addControl('confirmed', this.formBuilder.control(null, [Validators.required]));
  }
}
